import { Checkbox } from "@/components/ui/checkbox"
import { ExportParametersTabProps, ParameterSelectionListProps, ParameterSelectionSectionProps } from "."
import { Label } from "@/components/ui/label"

export function ExportParametersTab({ exportData, columnVisibility, setColumnVisibility }: ExportParametersTabProps) {
    return (
        <div className="">
            <ParameterSelectionSection
                parameter={exportData?.matched_configuration_with_default?.parameter?.crm}
                columnVisibility={columnVisibility}
                setColumnVisibility={setColumnVisibility}
                label="CRM"
            />
            <ParameterSelectionSection
                parameter={exportData?.matched_configuration_with_default?.parameter?.project}
                columnVisibility={columnVisibility}
                setColumnVisibility={setColumnVisibility}
                label="Project"
            />
            <ParameterSelectionSection
                parameter={exportData?.matched_configuration_with_default?.parameter?.survey}
                columnVisibility={columnVisibility}
                setColumnVisibility={setColumnVisibility}
                label="Survey"
            />
            <ParameterSelectionSection
                parameter={exportData?.matched_configuration_with_default?.parameter?.question}
                columnVisibility={columnVisibility}
                setColumnVisibility={setColumnVisibility}
                label="Question"
            />
        </div>
    )
}

function ParameterSelectionSection({ parameter, columnVisibility, setColumnVisibility, label }: ParameterSelectionSectionProps) {
    return (
        <div className="space-y-2">
            <p>{label} Parameters</p>
            {parameter && parameter.length > 0 ? (
                <ParameterSelectionList
                    columnVisibility={columnVisibility}
                    setColumnVisibility={setColumnVisibility}
                    parameter={parameter}
                />
            ) : (
                <p className="pb-2 text-sm text-muted-foreground">No {label} parameters</p>
            )}
        </div>
    )
}

function ParameterSelectionList({ columnVisibility, setColumnVisibility, parameter }: ParameterSelectionListProps) {
    return (
        <div className="">
            {parameter?.map((parameter) => (
                <div key={parameter.id} className="flex items-center justify-between w-full p-2">
                    <Label htmlFor={parameter.id}>{parameter.name}</Label>
                    <Checkbox
                        id={parameter.id}
                        checked={columnVisibility[parameter.name]}
                        onCheckedChange={(checked) => {
                            if(checked === 'indeterminate') return
                            setColumnVisibility((old) => ({
                                ...old,
                                [parameter.name]: checked
                            }))
                        }}
                    />
                </div>
            ))}
        </div>
    )
}